import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { X } from 'lucide-react'

const RouteComponent = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-10">
      <div className="p-6 bg-disabled w-fit rounded-xl">
        <X className="size-12 text-primary" />
      </div>
      <div className="flex flex-col items-center text-center gap-2.5">
        <p className="text-xl font-medium">Sayfalar Görüntülenemiyor</p>
        <p className="font-medium">
          Giriş yaptığınız kullanıcı rolü ekranları görüntülemek için yeterli
          değildir.
        </p>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_auth/_withProject/no-permissions')({
  beforeLoad: ({ context }) => {
    if (context.auth.user && context.auth.user?.permissions?.length > 0) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})


